import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import DistributionNavigation from '../DistributionNavigation'
import DistributeEmptyState from '../../../UniformComponents/DistributeEmptyState'
import Button from '../../../UniformComponents/Button'
import Panel from '../../../UniformComponents/Panel'
import DataTable from '../../DataTable'
import CampaignLinksModal from '../CampaignLinks/CampaignLinksModal'
import QR from '../../UserCampaign/QR'
import DeleteModal from '../Modal/DeleteModal'

@observer
class QrCode extends Component {
    constructor(props) {
        super(props)

        const { distributeStore } = props

        if (distributeStore.isRapidSurvey()) {
            distributeStore.goToCampaignLinks()
        }

        distributeStore.campaignType = 'qr'
        distributeStore.getCampaigns('qr')
    }

    getColumns = () => {
        const { distributeStore, store } = this.props
        const { survey } = store

        return [
            {
                key: 'campaigntitle',
                name: 'Title',
                dataTransform: (value, row) => (
                    [
                        <span className="campaign-links-row-title">{value}</span>,
                        <QR uuid={row.campaignId} campaignLink={survey.getCampaignLink(row.uuid, row.langCode, store.useLatestUI)} />,
                    ]
                ),
            },
            {
                key: 'campaignId',
                name: '',
                dataTransform: (value, row) => (
                    <div className="campaign-links-table-actions pad-top">
                        <i className="fal fa-download" onClick={(e) => distributeStore.downloadQR(e, value, row.uuid)} />
                        <i className="fal fa-edit" onClick={(e) => distributeStore.editCampaign(e, row)} />
                        <i className="fal fa-circle-xmark" onClick={() => distributeStore.showDeleteModal(row.campaignId)} />
                    </div>
                ),
                cellClass: 'center w50 pointer',
            },
        ]
    }

    render() {
        const { distributeStore, store } = this.props
        const { filteredList } = distributeStore

        return (
            <div className="email-landing-content">
                <DistributionNavigation store={distributeStore} survey={store.survey} />

                <div className="email-landing-right-container">
                    <Panel style={{ padding: 20, overflow: 'visible' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h2>{i18n.t('distributionQrCode.title')}</h2>

                            <Button
                                cssClass="regular tertiary"
                                onClick={distributeStore.showCampaignModal}
                                icon="fal fa-qrcode"
                                label={i18n.t('distributionQrCode.create')}
                            />
                        </div>
                    </Panel>

                    {!filteredList.length && !distributeStore.filterText.length
                        ? (
                            <DistributeEmptyState
                                title={i18n.t('distributionQrCode.emptyStateText')}
                                subtext={i18n.t('distributionQrCode.emptyStateSubText')}
                                ctaText={i18n.t('distributionQrCode.create')}
                                icon="fal fa-qrcode"
                                ctaIcon="fal fa-qrcode"
                                onClick={distributeStore.showCampaignModal}
                            />
                        ) : (
                            <Panel style={{ padding: 0 }}>
                                <DataTable
                                    store={distributeStore}
                                    dataSet={filteredList}
                                    inMemory
                                    columns={this.getColumns()}
                                />
                            </Panel>
                        )}
                </div>

                <CampaignLinksModal distributeStore={distributeStore} />

                <DeleteModal distributeStore={distributeStore} />
            </div>
        )
    }
}

export default QrCode
